/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { User } from 'oidc-client';
import { UserDto, RoleDto } from 'api/models';

export class UserMapper {
  mapToObject(tidUser: User): UserDto {
    const newObject = {
      userID: tidUser.profile['sub'],
      email: tidUser.profile['email'],
      fullName: `${tidUser.profile['family_name']} ${tidUser.profile['given_name']}`,
      role: RoleDto.None

    } as UserDto;
    return newObject;
  }
}
